export default __webpack_public_path__ + "static/media/privilege-gift.8a20ae80.svg";